import { Page, Text, View } from "@react-pdf/renderer";
import React from "react";
import CfmReportStyles from "../CfmReportStyles"; // adjust if path differs

let globalPageCounter = 1;

const Header = ({ pageNumber, title, subText, styles, tradingName }) => {
  if (pageNumber === 1) return null;

  return (
    <View style={styles.titleBarContainer} fixed>
      <View
        style={{
          ...styles.titleBar,
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <View
          style={{
            alignItems: "flex-start",
            gap: 8,
          }}
        >
          <Text style={styles.headerTitle}>{title}</Text>
          <Text style={styles.subText}>{subText}</Text>
        </View>
        <View
          style={{
            alignItems: "flex-end",
            gap: 8,
          }}
        >
          <Text style={styles.subText}>{tradingName}</Text>
          <Text style={styles.subText}>{pageNumber}</Text>
        </View>
      </View>
    </View>
  );
};

const Footer = ({ pageNumber, styles, footerText }) => {
  if (pageNumber === 1) return null;
  return (
    <View style={styles.footer} fixed>
      <Text style={styles.footerText}>{footerText}</Text>
    </View>
  );
};

const PageWrapper = ({
  children,
  tradingName,
  headerTitle,
  headerSubText,
  primaryColor,
  footerText,
  ...props
}) => {
  const pageNumber = globalPageCounter++;
  const styles = CfmReportStyles(primaryColor);

  return (
    <Page {...props} wrap={true}>
      <Header
        pageNumber={pageNumber}
        title={headerTitle}
        subText={headerSubText}
        styles={styles}
        tradingName={tradingName}
      />
      {pageNumber !== 1 && (
        <View style={styles.bubblesWrapper}>
          <View style={styles.bubbleOuter} />
          <View style={styles.bubbleMiddle} />
          <View style={styles.bubbleInner} />
        </View>
      )}

      <Footer
        pageNumber={pageNumber}
        styles={styles}
        footerText={
          footerText ||
          "Rosemount Financial Solutions (IFA) Ltd is authorised and regulated by the Financial Conduct Authority (FCA). Entered on the FCA Register (https://register.fca.org.uk/) under reference 535515. Rosemount Financial Solutions (IFA) Ltd is registered in England and Wales, Registered No. 05668905, Registered Address Rosemount House, 2 – 4 Chequers Road, Basingstoke, RG21 7PU."
        }
      />
      {children}
    </Page>
  );
};

export const resetPageCounter = () => {
  globalPageCounter = 1;
};

export default PageWrapper;
